import { CnpjMask } from './CnpjMask';
import { CpfMask } from './CpfMask';

export const DocumentMask = (document: string): string => {
  const replaceValue = document.replace(/\D/g, '');

  if (replaceValue.length <= 11) {
    return CpfMask(replaceValue);
  } else {
    return CnpjMask(replaceValue);
  }
};
